const setFristChildrenTitle = (id = null, val = null) => {
  return {
    type: 'SET_FRISTCHILDRENTITLE',
    id,
    data: val,
  }
}

export default {
  setFristChildrenTitle,
}